import { SalesforceSortOrder } from '../../enums/salesforce/salesforce-sort-order';

export class SalesforceSortItem {
	field: string;
	sortDir: SalesforceSortOrder = SalesforceSortOrder.Ascending;

	constructor(field: string) {
		this.field = field;
	}
}
